import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchCaseStudies } from '@/lib/api';

export default function CaseStudies() {
  const [studies, setStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchCaseStudies()
      .then(setStudies)
      .catch(() => setStudies([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="case-studies-page">
      
      <section className='pt-20 pb-16 border-b border-[#1a1a1a] hero-grid diag-lines inner-hero'>
        <div className="container-r360">
          <div className="highlights-kicker text-blue">
            <span />
           VERIFIED RESULTS || CPS MODEL
          </div>
          <h1 className="font-display font-bold leading-[0.92] tracking-[-0.035em] text-[70px] sm:text-[4rem] md:text-[5.5rem] lg:text-[6.5rem]">
            REAL BRANDS.<br /><span className="accent">REAL</span> NUMBERS.
          </h1>
          <p className="reveal-on-scroll text-[17px] text-[#c9c9c9] font-bold leading-relaxed mt-4 max-w-6xl">
            Every result below was delivered under our CPS model. Clients paid zero until verified sales closed.
          </p>
        </div>
      </section>
      
      <section className='highlights-section'>
        <div className="container-r360 mt-20 border-[#1a1a1a]">
           <div className="highlights-kicker">
            <span />
            Our case studies
          </div>
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.75rem] sm:text-[4.5rem] lg:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626] mb-12">
           Proven across <span className='accent'>Verticals</span>
          </h2>
        {loading && <div className="py-20 text-center mono-label">LOADING…</div>}
        {studies.map((s) => (
          <Link
            to={`/case-studies/${s.slug}`}
            key={s.slug}
            className="grid grid-cols-1 lg:grid-cols-12 gap-6 py-10 border-t border-[#1a1a1a] hover:bg-white/80 transition-colors px-2"
            data-testid={`cs-card-${s.slug}`}
          >
            <div className="lg:col-span-3">
              <div className="text-[14px] accent font-bold mb-3">{s.industry.toUpperCase()}</div>
              <div className="font-display text-[32px] font-black">{s.brand}</div>
            </div>
            <div className="lg:col-span-6">
              <div className="text-[17px] font-bold leading-relaxed mb-4">{s.headline}</div>
              <div className="flex flex-wrap gap-2">
                {s.tags.map((t, i) => (
                  <span key={i} className="font-sans text-[11px] uppercase border bg-[#00e0ff] font-medium px-2 py-1 text-black ">{t}</span>
                ))}
              </div>
            </div>
            <div className="lg:col-span-3 grid grid-cols-3 gap-2 text-center">
              {s.metrics.map((m, i) => (
                <div key={i}>
                  <div className="accent font-display text-[24px] lg:text-[32px] font-extrabold leading-none">{m.value}</div>
                  <div className="text-[12px] text-[#212121] text-bold uppercase font-medium tracking-wider mt-2">{m.label}</div>
                </div>
              ))}
            </div>
          </Link>
        ))}
      </div>
      </section>
    </div>
  );
}
